module.exports = "<p>\n  Downloading Results...\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/results-download/results-download.component.html
// module id = ./src/app/results-download/results-download.component.html
// module chunks = main